export default "__VITE_ASSET__CzoeG$_2__"